<template>
  <generic-container
    v-bind:searchable="false"
    v-bind:show_plus="true"
    icon="list"
    :title="$t('document type list')"
    v-on:add="add"
  >
    <div class="ui form">
      <div
        class="fields"
        v-for="(document_type, index) in document_types"
        v-bind:key="index"
      >
        <div class="three column wide field">
          <label for v-if="index == 0">{{ $t("code") }}</label>
          <input
            type="text"
            name="gpspaycode"
            v-model="document_types[index].gpspaycode"
          />
        </div>
        <div class="ten column wide field">
          <label for v-if="index == 0">{{ $t("name") }}</label>
          <input type="text" name="name" v-model="document_types[index].name" />
        </div>

        <div class="three column wide field">
          <label for v-if="index == 0">{{ $t("options") }}</label>
          <div class="ui mini red icon button" v-on:click="remove(index)">
            <i class="trash icon"></i>
          </div>
        </div>
      </div>
    </div>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import { v4 } from "uuid";

export default {
  name: "TibixConfigurationModalDocumentTypes",
  components: { GenericContainer },
  data() {
    return {
      document_types: [],
    };
  },
  methods: {
    add() {
      let vm = this;
      vm.document_types.push({
        id: v4(),
        gpspaycode: "",
        name: "",
      });
    },
    remove(index) {
      let vm = this;
      vm.document_types.splice(index, 1);
    },
    getList() {
      return this.document_types;
    },
    setList(list) {
      this.document_types = list;
    },
  },
};
</script>
